export var HTTP_STATUS_CODE;
(function (HTTP_STATUS_CODE) {
    HTTP_STATUS_CODE[HTTP_STATUS_CODE["OK"] = 200] = "OK";
    HTTP_STATUS_CODE[HTTP_STATUS_CODE["CREATED"] = 201] = "CREATED";
    HTTP_STATUS_CODE[HTTP_STATUS_CODE["ACCEPTED"] = 202] = "ACCEPTED";
    HTTP_STATUS_CODE[HTTP_STATUS_CODE["NO_CONTENT"] = 204] = "NO_CONTENT";
    HTTP_STATUS_CODE[HTTP_STATUS_CODE["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    HTTP_STATUS_CODE[HTTP_STATUS_CODE["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    HTTP_STATUS_CODE[HTTP_STATUS_CODE["FORBIDDEN"] = 403] = "FORBIDDEN";
    HTTP_STATUS_CODE[HTTP_STATUS_CODE["NOT_FOUND"] = 404] = "NOT_FOUND";
    HTTP_STATUS_CODE[HTTP_STATUS_CODE["CONFLICT"] = 409] = "CONFLICT";
    HTTP_STATUS_CODE[HTTP_STATUS_CODE["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
    HTTP_STATUS_CODE[HTTP_STATUS_CODE["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
})(HTTP_STATUS_CODE || (HTTP_STATUS_CODE = {}));
export var HTTP_STATUS_CODE_TEXT;
(function (HTTP_STATUS_CODE_TEXT) {
    HTTP_STATUS_CODE_TEXT["SUCCESS"] = "success";
    HTTP_STATUS_CODE_TEXT["FAIL"] = "fail";
    HTTP_STATUS_CODE_TEXT["ERROR"] = "error";
})(HTTP_STATUS_CODE_TEXT || (HTTP_STATUS_CODE_TEXT = {}));
export const HTTP_HEADER = {
    LANGUAGE: 'x-language',
};
/**
 * The largest page a list route serves. Shared with the web apps so a picker that needs a whole
 * short list (roles, permissions) asks for exactly what the API allows.
 */
export const LIST_PAGE_MAX_SIZE = 100;
